import "./style.scss";
interface ITermsConditionsSection {
  cancellationPolicies: { terms: string[] }[];
  cancellationTableData: string[];
  reschedulePolicies: { terms: string[] }[];
  rescheduleTableData: string[];
  reinstatePolicies: string[];
  splitPolicies: boolean;
}

const TermsConditionsSection: React.FC<ITermsConditionsSection> = (props) => {
  const { cancellationTableData, cancellationPolicies, rescheduleTableData, reschedulePolicies, reinstatePolicies, splitPolicies } = props;
  return (
    <>
      <div className="terms-conditions-wrapper">
        <span className="main-heading">CANCELLATION & RESCHEDULE POLICIES</span>
        <div className="tabular-policies-section-wrapper">
          <div className="left-wrapper">
            <span className="main-heading">Cancellation Policy</span>
            <table className="table">
              <thead>
                <tr>
                  <th scope="col">Days to Departure</th>
                  <th scope="col">Cancellation Fee</th>
                </tr>
              </thead>
              <tbody>
                {(cancellationTableData || [])?.map((data: any, index: number) => (
                  <tr key={index}>
                    <td>{data?.title}</td>
                    <td>{data?.fee_description}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <ul>
              {(cancellationPolicies?.[0]?.terms || [])?.map((point: string, index: number) => {
                return <li key={index}>{point}</li>;
              })}
            </ul>
          </div>
          <div className="right-wrapper">
            <span className="main-heading">Reschedule Policy</span>
            <table className="table">
              <thead>
                <tr>
                  <th scope="col">Days to Departure</th>
                  <th scope="col">Cancellation Fee</th>
                </tr>
              </thead>
              <tbody>
                {(rescheduleTableData || [])?.map((data: any, index: number) => (
                  <tr key={index}>
                    <td>{data?.title}</td>
                    <td>{data?.fee_description}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <ul>
              {(reschedulePolicies?.[0]?.terms || [])?.map((point: string, index: number) => {
                return <li key={index}>{point}</li>;
              })}
            </ul>
          </div>
        </div>
        <div className="non-tabular-policies-section-wrapper">
          {splitPolicies && <div className="left-wrapper">
            <span className="main-heading">Split Payment Policy</span>
            <ul>
              <li>The balance payment must be made within 48 hours of the first payment.</li>
              <li>If full payment is not received within the stipulated 48 hours, the booking will be cancelled, and all paid amounts will be forfeited.</li>
              <li>If the booking is cancelled due to non-payment, the guest is allowed to reinstate the booking as per the reinstatement policy.</li>
            </ul>
          </div>}
          <div className="right-wrapper">
            <span className="main-heading">Reinstate Policy</span>
            <ul>
              {(reinstatePolicies || [])?.map((point: string, index: number) => {
                return <li key={index}>{point}</li>;
              })}
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default TermsConditionsSection;
